const styleSelects = require("./../../blocks/styled-select/styled-select.js");

jQuery(function() {
  styleSelects.styleSelects($('.js-styled-select'));
  $('#dealer-select-city').on('change', function(e) {
    e.preventDefault();
    location.href = '/zayavka-dilera/?city=' + $(this).val();
  })
});



// WEBPACK FOOTER //
// ./blocks/dealer-select-city/dealer-select-city.js